export const environment = {
  name: 'yaraqa',
  api: 'https://portalcc-qas.yarabrasil.com.br/api/',
  production: false
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts